import moment from 'moment';
import { Country } from 'src/shared/types/Common';
import { ICountryImmigrationData, IImmigrationSnapshot } from 'src/shared/types/Immigration';

export enum SnapshotCountryCode {
  UnitedKingdom = 'GB',
  Ireland = 'IE',
  UnitedStates = 'US',
}

export const SNAPSHOT_COUNTRIES = [
  // SnapshotCountryCode.UnitedKingdom,
  // SnapshotCountryCode.Ireland,
  SnapshotCountryCode.UnitedStates,
];

export const getUniqueCountries = (countries: ICountryImmigrationData[]): Country[] =>
  Array.from(
    new Map(
      countries
        .filter(({ country }) => SNAPSHOT_COUNTRIES.includes(country as SnapshotCountryCode))
        .map(({ country, countryName }) => [country, { countryCode: country, countryName: countryName }])
    ).values()
  ).sort((a, b) => b.countryCode.localeCompare(a.countryCode));

export const getDropdownLabel = (name: string, relationship: string) => {
  const formattedRelationship = relationship
    ? relationship.charAt(0).toUpperCase() + relationship.slice(1).toLowerCase()
    : '';
  return `${name} (${formattedRelationship})`;
};

const isSnapshotHidden = (snapshot: IImmigrationSnapshot, isUS: boolean) => {
  const { immigrationDocumentUS: docUS, immigrationDocumentGBIE: docGBIE } = snapshot;
  if (isUS) {
    return !(
      docUS?.status ||
      docUS?.expirationDate ||
      docUS?.petitionExpiration ||
      docUS?.visaClassification ||
      docUS?.visaExpiration ||
      docUS?.niveadExpiration ||
      docUS?.iveadExpiration ||
      docUS?.apExpiration ||
      docUS?.finalI94
    );
  } else {
    return !(
      docGBIE?.classification ||
      docGBIE?.workPermitExpirationDate ||
      docGBIE?.residencePermitExpirationDate ||
      docGBIE?.entryPermitExpirationDate
    );
  }
};

export const getHiddenCountries = (
  countryList: Country[],
  immigrationSnapshots: Record<string, IImmigrationSnapshot[]>
): { countryCode: string; id: number }[] => {
  if (!countryList.length) return [];
  return countryList.flatMap((country) => {
    const snapshots = immigrationSnapshots[country.countryCode] || [];
    const isUS = country.countryCode === SnapshotCountryCode.UnitedStates;
    return snapshots
      .filter((snapshot) => isSnapshotHidden(snapshot, isUS))
      .map((snapshot) => ({ countryCode: country.countryCode, id: snapshot.beneId ?? snapshot.dependentId }));
  });
};

/**
 * Function to get the maximum expiration date between two EAD expiration dates.
 */
export const getEadExpiration = (iveadExpiration: string, niveadExpiration: string) => {
  const dates = [iveadExpiration, niveadExpiration].filter(Boolean).map((date) => moment.utc(date));
  return dates.length ? moment.max(dates).toISOString() : undefined;
};
